<template>
  <div id="app" @click="closeAllMenus" >  <!-- :class="{bgImg: $route.path == '/'}" -->
   
   <div  id="navBG">
      <div id="nav" >
        <div class="mainHeader ">

        <nav class="navbar" role="navigation" aria-label="main navigation">
          <div class="navbar-brand">
            <div class="is-inline-block is-size-1 has-text-weight-bold has-text-coolGreen handCursor" @click="$router.push('/')">
           <!--  &nbsp;<span class="fourDotsMainLogo"><b>::</b></span>miimu -->
          <div class="left20">
             <img class="top12" src="@/assets/img/Miimu logo.png" width="165" :class="{homeLogoWidth: $route.fullPath == '/'}"/><br>
             <div v-if="$route.fullPath == '/'" class="getYourSh has-text-grey-light has-text-weight-normal left60 top-25 bottom20"> Get your e-life together!</div>
          </div>
          </div>&nbsp;&nbsp;
            <div id="refreshBTContainer"  class="is-inline-block"></div>

            <a id="burger" @click="toggleBurger($event)" role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="miimuMenu" :class="{burgerInHome: $route.fullPath == '/'}">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>   
            </a>
        </div>

        <div class="navbar-menu" id="miimuMenu">
          <div class="navbar-start">
            <div id="menuControls" :class="{top13: $route.fullPath == '/'}">
              <router-link to="/bundles" class="navbar-item is-inline-block" draggable="false" :class="{menuControlsSelected: az.noSlash($route.path).startsWith('/bundles')}">bundles</router-link>
              <span class="has-text-white has-text-weight-light"> &nbsp;| </span>
              <router-link v-if="isAuth" :to="'/profile'" :key="$route.fullPath" draggable="false"  class="navbar-item is-inline-block" :class="{menuControlsSelected: az.noSlash($route.path).startsWith('/profile')}">profile</router-link>
              <span v-if="isAuth" class="has-text-white has-text-weight-light"> &nbsp;| </span>
              <router-link to="/discover" class="navbar-item is-inline-block" draggable="false" :class="{menuControlsSelected: az.noSlash($route.path).startsWith('/discover')}">discover</router-link>
              <span v-show="!inApp" class="has-text-white has-text-weight-light">&nbsp;| </span>
              <router-link v-if="!inApp && !userAttrs.hasUpgraded" to="/pricing" class="navbar-item is-inline-block" draggable="false" :class="{menuControlsSelected: az.noSlash($route.path).startsWith('/pricing')}">pricing</router-link>

<!--               <router-link to="/profile" class="navbar-item is-inline-block" :class="{menuControlsSelected: az.noSlash($route.path) == '/a'}">faq/help</router-link>
              <span class="has-text-white has-text-weight-light"> &nbsp;| </span>
              <router-link to="/profile" class="navbar-item is-inline-block" :class="{menuControlsSelected: az.noSlash($route.path) == '/a'}">About Us</router-link>
              <span class="has-text-white has-text-weight-light"> &nbsp;| </span>
              <router-link to="/profile" class="navbar-item is-inline-block" :class="{menuControlsSelected: az.noSlash($route.path) == '/a'}">Contact</router-link> -->
            
            </div>
          </div>
          <div v-if="$root.app.DEBUG">
            <span class="has-text-white has-text-weight-bold">hasUpgraded: {{ $root.app.userAttrs.hasUpgraded }}, </span>
            <span class="has-text-white has-text-weight-bold">bundleLimit: {{ $root.app.userAttrs.bundleLimit }}, </span>
            <span class="has-text-white has-text-weight-bold">cardLimit: {{ $root.app.userAttrs.cardLimit }}</span>
          </div>

          <div class="navbar-end">
             
       
                  <button id="loginButt" class="is-pulled-right button top25 is-coolGreen is-small right10" @click="showModalLogin({})" v-if="!isAuth">LOG IN</button>
            </div>

            </div>

            <div class="navbar-item has-dropdown is-arrowless is-inline-block" @click="openAccountMenu"  id="accMenu" v-if="isAuth">
                  <a class="navbar-link is-arrowless" id="accMenuTrig">
                    <i class="fa fa-user has-text-light top2" style="font-size: 23px"></i>
                  </a>
      
                  <div v-show="mainMenuOpen " class="" id="accountMenu2">
                  
                   <!--  <router-link class="navbar-item" :to="{name: 'profiledelegate', params: {propProfile: userAttrs.profile}}">
                      Profile
                    </router-link>
                      <div class="navbar-item has-text-light handCursor" @click="openFeed">
                      Feed
                    </div> -->
                    <router-link class="navbar-item" to="/accsettings">
                      Account
                    </router-link>
                   <!--  <router-link class="navbar-item" to="/preferences">
                      Preferences
                    </router-link> -->
                    <router-link class="navbar-item" to="/connects">
                      Collab Network
                    </router-link>
                    <div v-if="!$root.app.inApp && !userAttrs.hasUpgraded" class="navbar-item has-text-white handCursor" @click="upgrade">
                      {{ $root.app.userAttrs.hasUpgraded ? 'Manage Subscription' : 'Upgrade' }}
                    </div>
                    <div class="navbar-item has-text-white handCursor" @click="showWelcome">
                      Welcome Tour
                    </div>
                    <button  id="logoutButt" class="button is-small is-coolGreen xs  top10" @click="doLogout" >LOG OUT</button><br>
                    <!-- <button  class="button is-coolGreen xs top30 left15" @click="fullReload">Full Reload</button> -->
                    <div class="has-text-white top5 has-text-weight-normal">&nbsp;v. {{version}}</div>
                  </div>
            </div>
           

            <div v-show="isAuth" id="envelope" class="navbar-item handCursor posRelative" @click="openNotifications">
              <div v-show="unRead" class="notCount">
                  <div>{{unRead}}</div>
              </div>
              <div><i class="fa fa-bell has-text-light"></i></div>
            
            </div>


          </nav>
        </div>
      </div>
   </div>
    <!-- <div class="has-text-center has-text-dark">{{tebi}}</div> -->
    <router-view :key="$route.fullPath" id="routerView"  ref="routerView"/>
    

     <div v-show="rightBar" id="rightBar" :class="{rightBarCentered: rightBarComponent == 'comments'}">
        <div>
         <!--  <div class="delete is-pulled-right top3 right5 has-background-grey" style="z-index: 10; position: fixed; right: 10px" @click="closeRightBar">x</div> -->
         
          <component ref="rightBarComp" :is="rightBarComponent" :obj="rightBarObj"></component>
          

          <div>


          </div>

        </div>
      </div>

  	

    <full-spinner v-if="showFullSpinner"></full-spinner>

     <div id="dragger" style="position: relative; left: -550px; display: inline-block"><i class="fa fa-file has-text-dark fa-4x"></i></div>
     <div id="bundleDragger" style="position: relative; left: -500px; display: inline-block;">
       <i class="fas fa-band-aid has-text-dark fa-4x"></i><br>
       <div class="is-size-7 top-5">{{bundleDraggerText}}</div>
    </div>
     <div id="bundleDraggerSmall" style="position: relative; left: -500px; display: inline-block; ">
       <i class="fas fa-band-aid has-text-dark fa-3x"></i><br>
       <div class="is-size-7 top-5">{{bundleDraggerText}}</div>
     </div>

    <modal v-if="showModal" ref="mainModal">
			<component v-bind:is="loadedModalComponent" v-bind="modalPropsObj" @close="closeModal"></component>
		</modal>

    <v-tour style="z-index: 11100; position:relative; top: 0; left: 0" ref="welcomeTour"  name="myTour" :steps="steps" :callbacks="mainTourCallbacks" ></v-tour>
    <div v-show = "showTourMasks" id="mask1" style="position: absolute; width: 100vw; height: 10vh; background-color: rgba(0,0,0,.4); z-index: 11000"></div>
    <div v-show = "showTourMasks" id="mask2" style="position: absolute; width: 100vw; height: 10vh; background-color: rgba(0,0,0,.4); z-index: 11000"></div>
    <div v-show = "showTourMasks" id="mask3" style="position: absolute; width: 100vw; height: 10vh; background-color: rgba(0,0,0,.4); z-index: 11000"></div>
    <div v-show = "showTourMasks" id="mask4" style="position: absolute; width: 100vw; height: 10vh; background-color: rgba(0,0,0,.4); z-index: 11000"></div>
    
   
     
  </div>
</template>

<script>



import EditModal from './components/ModalEdit.vue'
import ScriptLoader from './components/ScriptLoader.vue'
import Modal from './components/Modal.vue'
import ModalOK from './components/ModalOK.vue'
import init from './static/static.js'
import cards from './static/cards.js'
import bundles from './static/bundles.js'
import ModalLogin from './components/ModalLogin.vue'
import MetricsDetail from './components/MetricsDetail.vue'
import ModalMakePublic from './components/ModalMakePublic.vue'
import ModalBundle from './components/ModalBundle.vue'
import ModalVerifyCode from './components/ModalVerifyCode.vue'
import Vue from 'vue'
import AZCognito from './components/AZCognito.vue'
import AZapiClient from './components/APIclient.vue'
import { AZEventBus } from './components/AZEventBus.js';
import ModalDeleteCard from './components/ModalDeleteCard'
import ModalConnectsInvite from './components/ModalConnectsInvite'
import ModalShare from './components/ModalShare'
import ModalMulti from './components/ModalMulti'
import ModalLightbox from './components/ModalLightbox'
import ModalDragbtoc from './components/ModalDragbtoc'
import ModalImport from './components/ModalImport'
import Notifications from './components/Notifications'
import ModalOfferUpdate from './components/ModalOfferUpdate'
import Welcome from './components/Welcome'
import EndTourMyTour from './components/EndTourMyTour'
import ModalAddMembers from './components/ModalAddMembers'
import ModalAddCollabMembers from './components/ModalAddCollabMembers'
import ModalNewPage from './components/ModalNewPage'
import History from './components/History'
import Feed from './components/Feed'
import ShareMiimu from './components/ShareMiimu'
import ShareProfile from './components/ShareProfile'
import Comments from './components/Comments'
import ModalUpg from './components/ModalUpg'
import FullSpinner from './components/FullSpinner'
import ModalBGroups from './components/ModalBGroups'

Vue.config.errorHandler = function(err, vm, info) {
	if(err.toString() == 'SecurityError: Failed to execute \'toDataURL\' on \'HTMLCanvasElement\': Tainted canvases may not be exported.')
		AZEventBus.$emit('imgCORSissue')
	console.log(` -- Error: ${err.toString()}\nInfo: ${info}`);
}

window.addEventListener(
  "message",
  (event) => {
      if(event.data && event.data.data && event.data.data.message == 'tabsToMiimus' && app.app.$route.path == '/extension' && !app.app.inApp ){
        //window.app.app.tabsToMiimus(event.data.data.tabs)
        window.app.app.$refs.mainModal.$children[0].showTabs(event.data.data.tabs)
      } else if(event.data && event.data.data && event.data.data.message == 'doRefresh'){
        window.app.app.loadUserBundles()
      }
  },
  false,   
);


require('./helpers/az')

function skip(){
  alert('skip')
}


export default {
    metaInfo: {
      title: 'miimu',
    },
    data: function(){
      return {
        checkLimits: true,
        az: az,
        showModal: false,
        loadedModalComponent: 'EditModal',
        modalPropsObj: {},
        init,
        showImages: true,
        bundles: [],
        tree: [],
        cards: [],
        cardsObj: {},
        tempId: 2000, //for dev of static version -- to assign new id to freshly created UrlCard,
        treeNoInbox: [],
        bundlesOpen: true,
        isAuth: false,
        goAfterLogin: '',
        goAfterPmtSrc: '',
        userAttrs: {},
        cartContents: [],
        staticBundles: bundles,
        staticCards: cards,
        timer: '',
        creds: '',
        loaded: false,
        tagUniverse: [],
        showFullSpinner: false,
        notifications: false,
        rightBar: false,
        nots: [],
        movingAdding: false,
        tebi: window.location.pathname,
        bundleDraggerText: 'asdfadfa',
        posThreshold: 0.000000000000000000000000001,
        posLimit: 16000,
        groupMembers: [],
        showNotifications: false,
        showHistory: false,
        rightBarComponent: null,
        rightBarObj: {},
        showRatings: true,
        multiView: true,
        ratings: [],
        ratingsAvg: [],
        ratingsMemAvg: [],
        fulled: false,
        fulledBundle: null,
        currentFilteredView: [],
        filterView: false,
        bundleGroups: [],
        currBundleGroup: 'All',
        currBundleGroupId: 0,
        inApp: false,
        fullLoad: false,
        showContext: false,
        filterByType: false, 
        lastFeed: null,
        dataTime: null,
        mainMenuOpen: false,
        windowWidth: window.innerWidth,
        showAds: false,
        firstPageLoaded: false,
        hideSearch: false, 
        isMobile: null,
        version: 5.5,
        unRead: 0,
        currPlan: 0,
        inExt: 0,
        autoSelectPlan: null,
        ads: [],
        ret: [], //temp for debug
        asyncScripts: [],
        checkoutTotal: [3.19, false],
        showTourMasks: false,
        secondaryModal: false,
        mainTourCallbacks: {
          onSkip: this.onSkip,
          onStop: this.onStop,
          onFinish: this.onFinish
        },
        steps: [
          {
            target: '#v-step-0',  
            header: {
              title: '1. Get Started',
            },
            content: 'Click the new miimu [+] sign',
            params: {
              enabledButtons: {
                buttonNext: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              this.elemForTour('v-step-0', {top: -8, bottom: 8}, 0)
              resolve('foo')
            })
          },
          {
            target: '#urlTextArea',
             header: {
              title: '2. Capture a link',
            },
            content: 'Copy + paste a web link into the orange bar. <br><br> You may also type out a web link and press return/enter.',
            params: {
              enabledButtons: {
                buttonNext: false,
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              this.elemForTour('urlTextArea')
              resolve('foo')
            })
          },
          {
            target: `${bundles.length ? '#editWindowRightPanel' : '#v-step-2'}`,
             header: {
              title: '3. Bundle it',
            },
            content: `Save your miimu in a new <b>bundle</b> or <b>sub bundle</b> by clicking the [+] sign. ${bundles.length ? '<b>OR</b> select an existing bundle to save it into.<br><b>NOTE:</b> If you do not make a selection, it will be saved into the inbox.' : ''}`,
            params: {
              placement: window.innerWidth > 497 ? 'bottom' : 'left',
              enabledButtons: {
                buttonNext: true,
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              setTimeout(() => {
                if(!document.getElementById('v-step-2')){
                  app.app.$refs.welcomeTour.skip()
                  this.secondaryModal = {message: 'Restart Tour?', callBack: this.startTour}
                  return
                }
                
              },15)
            
              //if(document.getElementById('v-step-2')){
                var el = bundles.length ? 'editWindowRightPanel' : '#v-step-2'
                this.elemForTour(el, {left: 4})
                resolve('foo')
              //}
            })
          },
          {
            target: '#v-step-3',
             header: {
              title: '4. Name your bundle',
            },
            content: 'Give it a name and then click NEXT',
            params: {
              enabledButtons: {
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              var self = this;
              if(this.$root.app.$refs.mainModal.$children[0].showNewModal){
                this.elemForTour('v-step-3')
                resolve('foo')
              } else {
                setTimeout(function(){
                  self.elemForTour('v-step-5')
                  self.$tours.myTour.currentStep = 5
                }, 20)
                
              }
            })
          },
          {
            target: '#v-step-4',
             header: {
              title: '5. Save your bundle',
            },
            content: 'Click Save',
            params: {
              enabledButtons: {
                buttonNext: false,
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              if(!this.$root.app.$refs.mainModal.$children[0].$refs.mns.bundleName ){
                reject('asdfa')
                return
              }
              

              var self = this;
              setTimeout(function(){
                self.elemForTour('v-step-4')
              }, 200)
              resolve('foo')

              
              //resolve('foo')
            })
          },
          {
            target: '#v-step-5',
             header: {
              title: '6. Add notes',
            },
            content: 'Open the <b>notes</b> panel',
            params: {
              placement: 'top',
              enabledButtons: {
                buttonNext: false,
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              var self = this;
              setTimeout(function(){
                self.elemForTour('v-step-5')
              }, 200)
              resolve('foo')
            })
          },
          {
            target: '#tagNotesContainer',
             header: {
              title: '7. Write your notes',
            },
            content: 'OPTIONAL: Add <b>notes</b> and click Next',
            params: {
              placement: 'top',
              enabledButtons: {
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              this.elemForTour('tagNotesContainer')
              resolve('foo')
            })
          },
          {
            target: '#v-step-6',
             header: {
              title: '8. Add tags',
            },
            content: 'Open the <b>tags</b> panel',
            params: {
              placement: 'top',
              enabledButtons: {
                buttonNext: false,
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              this.elemForTour('v-step-6')
              resolve('foo')
            })
          },
          {
            target: '#tagsContainer',
             header: {
              title: '9. Add tags',
            },
            content: 'OPTIONAL: Add <b>tag(s)</b> or click Next',
            params: {
              placement: 'top',
              enabledButtons: {
                buttonPrevious: false,
                buttonSkip: false
              }
            },
            before: type => new Promise((resolve, reject) => {
              this.elemForTour('tagsContainer')
              resolve('foo')
            })
          },
          {
            target: '#saveCardButt',
             header: {
              title: `10. You're there!`,
            },
            content: 'Save your <b>miimu</b>',
            params: {
              placement: 'top',
              enabledButtons: {
                buttonPrevious: false,
                buttonSkip: false,
                buttonStop: false
              }
            },
            labels: {
              buttonStop: 'Skip tour'
            },
            before: type => new Promise((resolve, reject) => {
              this.elemForTour('saveCardButt')
              resolve('foo')
            })
          },
          
        ],
        typeFilters: [
          {name: 'No Filter', id: false},
          {name: 'Dropbox', id: 'dropbox'},
          {name: 'Facebook', id: 'facebook'},
          {name: 'Google Docs', id: 'googledocs'},
          {name: 'Google Spreadsheets', id: 'googlesheets'},
          {name: 'Gmail', id: 'gmail'},
          {name: 'Instagram', id: 'instagram'},
          {name: 'Linkedin', id: 'linkedin'},
          {name: 'PDF', id: 'pdf'},
          {name: 'Pinterest', id: 'pintrest'},
          {name: 'Spotify', id: 'spotify'},
          {name: 'Trello', id: 'trello'},
          {name: 'Tumblr', id: 'tumblr'},
          {name: 'Twitter', id: 'twitter'},
          {name: 'WhatsApp', id: 'whatsapp'},
          {name: 'You Tube', id: 'youtube'}
        ],
        DEBUG: false,
        dummy: 1
      }
    },
    components:{
      EditModal,
      Modal,
      ModalOK,
      ModalLogin,
      ModalVerifyCode,
      ModalDeleteCard,
      ModalBundle,
      ModalShare,
      FullSpinner,
      ModalImport,
      ModalOfferUpdate,
      Notifications,
      ModalConnectsInvite,
      ModalAddMembers,
      ModalAddCollabMembers,
      ModalDragbtoc,
      History,
      Comments,
      ModalBGroups,
      ShareMiimu,
      ShareProfile,
      ModalMakePublic,
      Feed,
      ModalMulti,
      MetricsDetail,
      ModalNewPage,
      Welcome,
      ModalUpg,
      EndTourMyTour,
      ModalLightbox
    },
    created: function(){

      // Create the azCognito instance:
      var tempCog = Vue.extend(AZCognito)
      this.azCognito = new tempCog({
        propsData: { owner: this }
      })

      // Create the APIclient instance:
      var tempApiClient = Vue.extend(AZapiClient);
      this.apiClient = new tempApiClient({
        propsData: { owner: this }
      });
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
       

     
    },

    mounted: function(){

      document.getElementById('navBG').style.display = 'none'

      var self = this
   
      //Override any type an A tag is clicked
      document.onclick = function (e) {
        e = e ||  window.event;
        var element = e.target || e.srcElement;

        if (element.tagName == 'A') {
          var url = element.href
          

          //If in cms => emit event

          //If in help => emit event

          //If in Discover or any other page => figure out navigation?


          var idArr = url.split('/miimucms/') 
          if(idArr.length == 2){
            console.log('internal')
            AZEventBus.$emit('CMSpageNavigation', {id: idArr[1]}) 
            return false; // prevent default action and stop event propagation
          } else {
           
          }
          
        }
      };

      if(window.location.search.split('inApp=1').length > 1){
        this.inApp = true
      }

      if(window.location.search.split('inExt=1').length > 1){
        this.inExt = true
      }

      this.$nextTick(() => {
           window.addEventListener('resize', this.onResize);
      })

      if(window.innerWidth > 1023){
        this.isMobile = false
      } else {
        this.isMobile = true
      }

      //Google ads:
     // this.loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js', this.scriptLoaded)

      


      AZEventBus.$on('closeAllMenus', (msg) => {
        
        if(document.getElementById('miimuMenu').classList.contains('is-active')){
         self.toggleBurger({})
        }
        
        self.mainMenuOpen = false
        self.hideSearch = false

        if(window.innerWidth > 1023){
          self.isMobile = false
        } else {
          self.isMobile = true
        }
       
       
        //var el = document.getElementById('accMenu')
      
      /*   if(msg.path[1].id == 'accMenuTrig'){
          
        } else {
          self.$root.app.mainMenuOpen = false
          el.classList.remove('is-active')
          
        } */
          
      })

      
      //listen for messages when inside native App.
     

      var firstLoad = window.location.pathname
      var self = this

      this.startTimer()

      AZEventBus.$on('onFederate', msg => {
        console.log('federeated')
        self.doneFederating = true;
        if(self.userAttrs.sub){
          self.InitialDataLoad()
        } else {
          setTimeout(function(){
            if(self.userAttrs.sub){
              self.InitialDataLoad()
              console.log('delayed load')
            } else {
              if(self.inApp){
                window.webkit.messageHandlers.myMessageName.postMessage('loaded')
              }
            }
           
          }, 1000)
        }
      });

      setTimeout(async function () {
        var doIt = true

        // CHECK SESSION: conditional checks to see if should skip federation when loading after logging out from app
        //console.log(window.location.search.indexOf('sf=1') == -1)
      
        if(window.location.search.indexOf('sf=1') == -1){
          await self.azCognito.getUserAttributes(sessionCheckCallback);
          
          function sessionCheckCallback(result) {
          
            if (!result) {
              
            } else {
              // if conditional is true means email is not verified
              var ask = self.doAuthenticated(result);
              var toCheckout = false
              if (ask == true) {
                self.azCognito.logOutUser(null)
              } else if (ask == 'forceCheckout' && self.userAttrs['custom:isDisp'] != 'true'){
                toCheckout = true;
              }
            }

            

          /*   if(self.isAuth && window.location.pathname == '/'){
              self.$router.push('/bundles?prev=1')
              doIt = false
            } */
           
            loadFirstPage();
            

          }
        } else {
          loadFirstPage()
        }

        document.getElementById('navBG').style.display = 'block'

        function loadFirstPage(val) {

          document.getElementById('nav').style.display = 'block'

          if(az.getQueryVariable('ref') != false){
            document.cookie = "ref=" + az.getQueryVariable('ref');
          }

          
            if(val == 'home'){
              self.$router.push('/')
            } else if (val == 'checkout'){
              self.$router.push('/checkout')
            } else {

            let path = ''
            if(window.location.search.split('inApp=1').length > 1 && window.location.toString().split('extension').length == 1 ){
                //alert(window.location)
                path = '/bundles?prev=1&inApp=1' 
            } else {
                path = window.location.pathname + window.location.search
            }
           
            
            if(window.location.pathname == '/bundles'){
              path = window.location.pathname + '?prev=1'
            }
            if(doIt)
              self.$router.push(path)
          }
          self.firstPageLoaded = true;
          self.cartContents = JSON.parse(az.getCookieValue('cart')) || [];

        

         /*  AZEventBus.$once('onFederate', msg => {
           
          }); */
         

         
        }
      }, 100);
    },
    
    methods:{


      addDeleteToStep: function(){
        var el = this.$refs.welcomeTour.$children[0].$el

        var d = document.createElement('div')
        d.setAttribute('class', 'delete stepDelete')
        d.setAttribute('onClick', 'app.app.$refs.welcomeTour.skip()')
        el.append(d)
      },

      tester: function(){
        alert('works')
      },

      elemForTour: function(id, offsets, step){

        var self = this;

        setTimeout(function(){
            window.scrollTo(0,0)
         
            var el = document.getElementById(id);
            var bodyRect = document.body.getBoundingClientRect();
            var elemRect = el.getBoundingClientRect();

           


            var oLeft = 0
            var oRight = 0
            var oTop = 0
            var oBottom = 0
            
            if(offsets){
              oLeft = offsets.left || 0;
              oRight = offsets.right || 0;
              oTop = offsets.top || 0;
              oBottom = offsets.bottom || 0;
            }


            var top = elemRect.top - oTop
            var left = elemRect.left - oLeft
            var right = elemRect.right + oRight;
            var bottom = elemRect.bottom + oBottom
          
            console.log(top, left, right, bottom)

            var m1 = document.getElementById('mask1')
            var m2 = document.getElementById('mask2')
            var m3 = document.getElementById('mask3')
            var m4 = document.getElementById('mask4')

            

            m1.style.top = 0
            m1.style.height = top + 'px'

            m2.style.height = screen.height - bottom + 'px'
            m2.style.top = bottom + 'px'


            m3.style.left = right + 'px'
            m3.style.top = top  + 'px'
            m3.style.width = screen.width - right + 'px'
            m3.style.height = bottom - top + 'px'

            m4.style.left = 0
            m4.style.top = top + 'px'
            m4.style.width = left + 'px'
            m4.style.height = bottom - top + 'px'

            self.addDeleteToStep()

            if(step == 0){
              document.getElementById('inboxHeader').style.position = 'relative'
              document.getElementById('inboxHeader').style.top = '8px'
            }

            
          },400

        )
      },

      upgrade: function(){
        if (!this.$root.app.userAttrs.hasUpgraded) {
          this.doShowModal('ModalUpg', {})
        } else {
          this.$router.push('/accsettings');
        }
      },
     
      fullReload: function(){
        if(this.inApp){
          window.location.assign("https://miimu.com?inApp=1")
        } else {
          window.location.reload()
        }
        
      },

      startTour: function(){
          var self = this;
         
          if(!this.$route.fullPath.startsWith('/bundles'))
            this.$router.push('/bundles')

          if(!self.$refs.routerView.inbox)
            self.$refs.routerView.toggleInbox()
          
          setTimeout(function(){
            self.showTourMasks = true
            self.closeModal()
            self.$refs.routerView.$refs.theInbox.showUrlBar = false

            self.$tours['myTour'].start()
          }, 200)
          
      },

      scriptLoaded: function(){
        window.googletag = window.googletag || { cmd: [] };
      },


      showModalVerifyCode: function () {
        this.loadedModalComponent = 'ModalVerifyCode'
        this.showModal = true
      },
      openAccountMenu: function (e) {
        e.stopPropagation();
        this.mainMenuOpen = true
        this.hideSearch = true
       /*  if (el.classList.contains('is-active')) {
          az.hideOnClickOutside('accMenu', ['accMenuTrig'])
        } else {
          if (el == '!accMenu') {
            document.removeEventListener('click', outsideClickListener)
          }
        } */
      },
      doShowModal: function(component, obj){
        this.modalPropsObj = obj;
        this.loadedModalComponent = component;
        this.showModal = true;
      },



      blurBG: function(){
        var self = this
        this.$nextTick(function(){
            self.$refs.routerView.$el.classList.add('bgBlur')
            //document.getElementById('routerView').classList.add('bgBlur')
            //document.getElementById('azFooter').classList.add('bgBlur')
            document.getElementById('nav').classList.add('bgBlur')
          }
        )
      },
      unBlurBG: function(){
        var self = this
        self.$refs.routerView.$el.classList.remove('bgBlur')
        //document.getElementById('azFooter').classList.remove('bgBlur')
        document.getElementById('nav').classList.remove('bgBlur')
      },

      showModalFullSpinner(){
        this.showFullSpinner = true
      },
      hideModalFullSpinner(){
        this.showFullSpinner = false
      },
      closeModal: function(){
        var self = this
        this.loadedModalComponent = null
        this.showModal = false;

        setTimeout(function(){
          if(self.secondaryModal){
            self.showModalOK(self.secondaryModal)
            self.secondaryModal = null
          }
        }, 5)
      },

      showModalOK: function (obj) {
        this.loadedModalComponent = 'ModalOK'
        this.modalPropsObj = obj
        this.showModal = true
      },

      saveLocal: function(){
        /* localStorage.setItem("bundles", JSON.stringify(this.bundles));
        localStorage.setItem("cards", JSON.stringify(this.cards));
        localStorage.setItem("tempId", JSON.stringify(this.tempId));
        
 */
        var self = this;

        function w(data){
          az.addRemSpinner(false, 'id', 'saveButt')
          self.$root.app.showModalOK({message: 'Data has been saved to backend database.'})
        }

        function n(e){
          az.addRemSpinner(false, 'id', 'saveButt')
          self.showModalOK({message: "There was an error saving data."})
        }

        az.addRemSpinner(true, 'id', 'saveButt')

        this.apiClient.put('subs/data', {bundles: JSON.stringify(this.bundles), cards: JSON.stringify(this.cards), tempId: this.tempId}, w, n)

        //localStorage.setItem("tree", JSON.stringify(this.tree));
        //localStorage.setItem("treeNoInbox", JSON.stringify(this.treeNoInbox));
      },

      toggleMainMenu: function(){
        this.mainMenuOpen = !this.mainMenuOpen
      },

      showModalLogin: function (obj) {
        
        this.loadedModalComponent = 'ModalLogin'
        this.modalPropsObj = obj
        this.showModal = true;

        document.getElementById('burger').classList.toggle('is-active');
        document.getElementById('miimuMenu').classList.toggle('is-active');
      },

      doAuthenticated: function (r, fromLogin) {

        var temp = {}
        for (var i = 0; i < r.length; i++) {
          temp[r[i].getName()] = r[i].getValue()
        }
        this.userAttrs = temp
       

        this.isAuth = true

        //this.startTimer()
        if (this.goAfterLogin != '') {
          this.$router.push(this.goAfterLogin)
          this.goAfterLogin = ''

          return
        }
        if (az.noSlash(this.$route.path) == '/forgot' || az.noSlash(this.$route.path) == '/unverified' || az.noSlash(this.$route.path) == '/register') {
          this.$router.push('/')
        } else if(az.noSlash(this.$route.path) == '' && this.firstPageLoaded){
          this.$router.push('/bundles?prev=1')
        }


        if ((this.userAttrs.email_verified == 'false') && fromLogin != true) {
          this.isAuth = false
          this.$router.push('/')
          return true
        } else if (this.userAttrs.email_verified == 'false' && fromLogin) {
          this.isAuth = false
          this.$router.push('/')
          this.showModalVerifyCode()
          return false
        }

       /*  if (fromLogin == true && az.noSlash(this.$route.path) == '') { 
          this.$router.push('/bundles')
        } */
       /*  if(this.isAuth && (this.userAttrs['custom:bundle'] != undefined && this.userAttrs['custom:bundle'] != '' )){
          this.cartContents = JSON.parse(JSON.parse(this.userAttrs['custom:bundle']).regCart);
          this.cartToCookie();
          this.$router.push('/checkout');
          return 'forceCheckout';
        } */

       
        
      },
      doLogout: function () {
        
        var self = this
        this.azCognito.logOutUser(logOutCallback)
        //this.stopTimer();

        document.getElementById('burger').classList.toggle('is-active');
        document.getElementById('miimuMenu').classList.toggle('is-active');

        function logOutCallback(result) {

          if (result == 'error') {

          } else if (result == 'success') {
            //// INSERT APP HOOK to copy local storage
            if(self.inApp){
              window.webkit.messageHandlers.myMessageName.postMessage("writeLocal")
              //self.showModalFullSpinner()
              setTimeout(function(){
                window.location.href = '/?inApp=1&sf=2'  //if sf is set to 1, federation will be skipped when reloading the page for a new login.
              }, 100)

            } else if(!self.inApp && az.noSlash(self.$route.path) == '/extension') {
              top.window.postMessage({data: {message: 'closeIt'}}, "*");
            } else {
              window.location.href = '/'
            }
            
            
            return
            self.isAuth = false
            if (self.$route.meta.secure || self.$route.name == 'profile') {
              self.$router.push('/')
              self.tree = undefined;
              self.treeNoInbox = undefined;
              self.bundles = [];
              self.cards = [];
              self.tempId = 0;
              self.$root.app.closeModal()
              self.$root.app.rightBar = false;
            }
          }
        }
      },
      cartToCookie(){
        document.cookie = "cart=" + JSON.stringify(this.cartContents);
      },

      refreshSession: async function(){
			  await this.azCognito.refreshSession()
      },
      
      startTimer: function(){
        this.timer = new Date();
        this.timer = this.timer.setMinutes(this.timer.getMinutes() + 20);     //setInterval(self.refreshSession, 840000)
      },

      openHistory: function(id, collabId, listName, listIndex, lastActivityId, caller){
        this.rightBarObj = null
        this.rightBarComponent = null
        var self = this
        setTimeout(function(){
          self.rightBarObj = {id: id, collabId: collabId, listName: listName, listIndex: listIndex, lastActivityId: lastActivityId, caller: caller}
          self.rightBarComponent = 'history'
          self.rightBar = true
        }, 2)
      },

      openFeed: function(id, collabId, listName, listIndex){
        this.rightBarObj = null
        this.rightBarComponent = null
        var self = this
        setTimeout(function(){
          self.rightBarObj = {}
          self.rightBarComponent = 'feed'
          self.rightBar = true
        }, 2)
      },

      openComments: function(item, bundleId, collabId){
        this.rightBarObj = null
        this.rightBarComponent = null
        var self = this;
        setTimeout(function(){
          self.rightBarObj = {item: item, bundleId: bundleId, collabId: collabId, inRightBar: true}
          self.rightBarComponent = 'comments'
          self.rightBar = true
        }, 2)
      }, 

      closeRightBar: function(){
        this.rightBarComponent = null
        this.rightBar = false
      },

      rePositioner: function(repos){

        

        var self = this

        repos.sort(function(a,b){
            return a.id_BUNDLES - b.id_BUNDLES
        })

       

        var currBundle = null
         let items = []
        repos.forEach(e => {
         
          if(e.id_BUNDLES != currBundle){
              
              if(items.length){
                items.sort(function(a,b){ return a.p - b.p})
              }

              items = self.bundles.find(o => {
                 return o.id == e.id_BUNDLES
              }).items
          }

          let theItem = items.find(i => {
            return i.id == e.id_CARDS
          })
      
          if(theItem)
            theItem.p = e.p
        })    
        
         items.sort(function(a,b){ return a.p - b.p})
        
      },

      nextTourStep: function(){
        if(this.$tours['myTour'].isRunning){
          this.$tours['myTour'].nextStep()
        }
      },

      endTour: function(tour){
        if(this.$tours[tour].isRunning){
          this.$tours[tour].stop()
          this.showTourMasks = false
          //show end of tour modal
          this.doShowModal('EndTourMyTour', {})
        }
      },

      cardMover: function(fromBundleId, cardId, toBundleId, before, after, app, callBack, cardsIndex, aliasTgtId){

        
        var self = this

        var newPos;
        var rePosition = false
        var nextPos = after
        var tgtInd = null

       /*  if(before && after){
            newPos = (before + after) / 2
            if(newPos - before < this.posThreshold){
              newPos = before + this.posLimit
              rePosition = true
            } 
        } else if(before && !after){
            newPos = 16000 + before 
        } else if(!before && after){
            newPos = after / 2
            if(after - newPos < this.posThreshold){
              newPos = this.posLimit
              rePosition = true
            }
        } else if(!before && !after){
            newPos = 16000
        } */


        let cardParents = this.cards[cardsIndex].parents
        
        let tgtParent = cardParents.find((e) => {
            return e.id ==  fromBundleId //  aliasTgtId ||
        })

        let entryId = tgtParent.entryId

        var bundle = self.bundles.find((e) => {
            return e.id == toBundleId
        })
  

        var bundle2 = self.bundles.find((e) => {
            return e.id == fromBundleId
        })

        var fromBeenSharedId = bundle2.beenShared ? bundle2.id : 0;
        var fromImportAcl = bundle2.importAcl

        if(fromImportAcl > 0){
          fromBeenSharedId = bundle2.id
        }

        
      
        function w(data){  

                self.movingAdding = false

                if(data.response == 'stale data'){
              
                  self.showModalOK({message: 'E1: Your data is not up to date. Please refresh and try again. We are working on a better way to sync data within collab bundles. Stay tuned. Refresh now?', callBack: self.refreshNow, payload: {}})
                  return
                }
            
                let card = self.cards[cardsIndex]
                  

                //let card = app.cardsObj['c' + cardId]
                //remove parent from card
                let toRemove = card.parents.findIndex((e) => {
                    return e.id == fromBundleId
                })
             
                card.parents.splice(toRemove, 1);

                /* if(data.foundADirty){
                  bundle2.dirt -= 1;
                  self.checkForRootDirtAlert(fromBundleId)
                } */

                
                //add parent to card

                
                card.parents.push({id: toBundleId, p: data.newP, entryId: data.response})

                

            //* push {id, pos} into to bundle items 
                setTimeout(function(){
                  bundle.items.push({id: cardId, p: data.newP, cardsIndex: cardsIndex, entryId: data.response})
                  bundle.items.sort((a,b) => {
                    return a.p - b.p
                  })
                }, 10)
               
  

               /*  if(data.makeDirty[0] == toBundleId){
                   bundle.dirt += 1;
                   self.checkForRootDirtAlert(toBundleId)
                } */

               
                 

            //* remove {id, pos} from from bundle
               

                let toRemove2 = bundle2.items.findIndex((e) => {
                    return e.id == cardId
                })
                bundle2.items.splice(toRemove2, 1)

               

                setTimeout(function(){
                  callBack()
                }, 2)
                

                if(rePosition){
                  if(data.repos){
                    self.rePositioner(data.repos)
                  }
                  
                }            
                
               
        }
        
        function n(){
           self.movingAdding = false
           self.showModalOK({message: "There was an error processing your request. Please try again or contact support"})
        }

        let tgtIsCollab = false
        let staticExisting = []
        if(bundle.collabId){
          cardParents.forEach(e => {
            if(!staticExisting.includes(e.id))
              staticExisting.push(e.id)
          })
          tgtIsCollab = true
          staticExisting.sort((a,b) => {
                return a - b;
            })
        }

        self.movingAdding = toBundleId

        if(aliasTgtId){
          toBundleId = aliasTgtId
        }

        //TODO have UrlCard send whether fromBundle has a collabId and pass this as true or false via doPerm property to backend to determine whether to run permission query
        this.$root.app.apiClient.put('subs/data/cardMove', {before: before, after: after, removeEntryId: entryId, reposition: rePosition, doCollabCheck: true, tgtIsCollab: tgtIsCollab, staticExisting: staticExisting, tgtCollabId: bundle.collabId, toAdd: {id_CARDS: cardId, id_BUNDLES: toBundleId, p: newPos, nextPos: nextPos,  beenShared: bundle.beenShared, fromBeenShared: fromBeenSharedId, importAcl: bundle.importAcl, fromImportAcl: fromImportAcl}}, w, n);
      },

      copyCardCallback: function(payload){
          this.closeModal()
          this.$nextTick(this.doShowModal('editModal', {url: payload.url, cardsIndex: payload.cardsIndex, callApi: false, caller: payload.caller, bundleId: payload.bundleId, copyCard: true, before: payload.before, after: payload.after, fromBundleId: payload.fromBundleId}))
        
      },

      readyForPaste: function(){ //when app has taken screen shot of miimu website
        AZEventBus.$emit('readyForPaste', {})
      },

      checkForRootDirtAlert: function(id){

        var b =  this.bundles.find(e => {
          return e.id == id
        })

        var isDirty = false;

        function rec(arr){
            arr.forEach(c => {
              if(c.dirt > 0) {
                isDirty = true
              } else {
                if(c.children.length) rec(c.children)
              }
            })
        }

        function processBundle(b){
          
          if(b.dirt > 0) {
            isDirty = true
          } else if(b.children.length){
            rec(b.children)
          }
        }

        if(b.isRoot){
          processBundle(b)
        } else {
          
          let bRoot = this.bundles.find(e => {
            return e.id == b.branch[0]
          })
          processBundle(bRoot)
        }

        if(isDirty){
          b.hasDirtyBundles = true
        } else {
          b.hasDirtyBundles = false
        }

        var idToFind = b.isRoot ? id : b.branch[0];

        var slotBundle = this.treeNoInbox.findIndex(i => {
          return i.id == idToFind
        })

        setTimeout(function(){
          if(slotBundle != -1)
            AZEventBus.$emit('setRootDirtyAlert', {slotBundle: slotBundle, isDirty: isDirty})
        }, 100)
       
        
      },

      closeAllMenus: function(ev){
         AZEventBus.$emit('closeAllMenus', ev)
      },

      activateHideGroup: function(g){
        if(g == 'all'){
          this.currentFilteredView = []
          this.filterView = false
          return
        }

        this.currentFilteredView = g.contents
        this.filterView = true
        
      },

      bundleMover: function(parentId, targetId, targetIndex, bundle, app, branch, listIndex, xxx, moveAddSpinnerTarget, aliasTgtId, collabId, callBack){

        /* console.log(parentId, targetId, targetIndex, bundle, app, branch, listIndex, xxx, moveAddSpinnerTarget, aliasTgtId, collabId)
        
        return */

        //get rootId
        var rb
        var rbt
        var rbt2
        rb = this.$root.app.bundles.find(e => {
          return e.id == bundle.branch[0]
        })
        var rootId = rb.aliasTgtId || rb.id

        var rbt //root bundle of target
        var tgtRootId
        if(targetId == 'root'){
          tgtRootId = bundle.id
        } else {
          rbt = this.$root.app.bundles.find(e => {
            return e.id == targetId
          })
          rbt2 = this.$root.app.bundles.find(e => {
            return e.id == rbt.branch[0]
          })
          tgtRootId = rbt2.aliasTgtId || rbt2.id
        }



          var self = this;
          var localTgtId; //used instead of targetId to find target bundle when moving bundle into root of collab

          function reBranch(ids, branch){
           
              for(var i=0; i < ids.length; i++){
                
                  var newBranch = branch.concat([ids[i].id])
                  
                  app.bundles.find(function(e){
                      if(e.id == ids[i].id){
                        
                        e.branch = newBranch
                        
                        if(e.children.length > 0){
                          reBranch(e.children, newBranch)
                        }
                        return true
                      }
                  })
              }
          }

          function w(data){
            
             self.movingAdding = false

             if(data.response == 'stale data'){
              
               self.showModalOK({message: 'E2: Your data is not up to date. Please refresh and try again. We are working on a better way to sync data within collab bundles. Stay tuned. Refresh now?', callBack: self.refreshNow, payload: {}})
               return
             }
             //remove from existing
            if(parentId != 'root'){
              
                let parentBundleInd = self.bundles.findIndex((e) => {
                    return e.id == parentId
                })

                let toRemove = self.bundles[parentBundleInd].children.findIndex((e) => {
                    return e.id == bundle.id
                })

                self.bundles[parentBundleInd].children.splice(toRemove, 1);
            } else {
                self.treeNoInbox.splice(listIndex, 1);
            }

            //add to target bundle
            let targetBundleInd = self.bundles.findIndex((e) => {
                return e.id == localTgtId
            })

            let temp 

            if(targetBundleInd != -1){
              temp = self.bundles[targetBundleInd].branch.slice()
              temp.push(bundle.id)
            } else {
                temp = [bundle.id]
            }

            bundle.branch = temp

            if(bundle.children.length > 0){
                reBranch(bundle.children, temp)
            }

            if(parentId == 'root'){
                bundle.isRoot = false
            } else if(targetId == 'root') {
                bundle.isRoot = true
            }



            if(targetId != 'root'){
              self.bundles[targetBundleInd].children.splice(targetIndex, 0, bundle)
            } else {
              bundle.p = newPos
              self.treeNoInbox.splice(targetIndex, 0, bundle)
              self.treeNoInbox.sort(function(a,b){ return a.p - b.p})
            }

            if(collabId == undefined)
              collabId = null;

            let toCh = data.response.split(',');
            toCh.forEach(e => {
              self.bundles.forEach(i => {
                if(i.id == e){
                  i.collabId = collabId
                }
              })
            })
            

            //Reposition neighbors if necessary
            if(data.repos){
              if(data.repos.length > 0){
                let arr = data.repos;
                arr.forEach(e => {
                  for(var i=0; i < self.treeNoInbox.length; i++){
                    if(self.treeNoInbox[i].id == e.id){
                      self.treeNoInbox[i].p = e.p
                      break
                    }
                  }
                })
                self.treeNoInbox.sort(function(a,b){ return a.p - b.p})
              }
            }

            if(callBack && parentId != 'root'){
              callBack()
            }

          }

          function n(){
            self.movingAdding = false
            self.showModalOK({message: "There was an error processing your request. Please try again or contact support3"})
          }

          //Pre api call stuff

  
          var parentArr = []
          var targetArr = []
          var tempo = []
          let same = false     
          var newPos = 0  
          var parentCollabId = null

          var tempParent = parentId
          var alias
          alias = this.$root.app.bundles.find(e => {
            return e.id == parentId
          })

          if(targetId == aliasTgtId){
            let bs = self.$root.app.bundles.find(e => {
              return e.aliasTgtId == targetId
            })

            localTgtId = bs.id

          } else {
            localTgtId = targetId
          }

  
          if(alias){ //means it is subBundle
            parentCollabId = alias.collabId || null
            if (alias.aliasTgtId){
              tempParent = alias.aliasTgtId
              
            }
          }

          if(parentId != 'root'){

            let parentBundleChildren = self.$root.app.bundles.find(e => {
              return e.id == parentId
            }).children

            tempo = [];

            for(let n=0; n < parentBundleChildren.length; n++){
              tempo.push(parentBundleChildren[n].id)
            }
          } 

          if(parentId == targetId){
            
              same = true
              //remove
              let indx  = tempo.findIndex(e => {
                return e == bundle.id
              })
              tempo.splice(indx, 1)

              //insert
              tempo.splice(targetIndex, 0, bundle.id) 

              parentArr = tempo;

          } else {

              //get new ParentArr
              parentArr = tempo.filter(e => {
                return e != bundle.id
              })

              if(targetId != 'root'){
                    //get new TargetArr

                    

                   



                    let targetBundleChildren = self.$root.app.bundles.find(e => {
                      return e.id == localTgtId
                    }).children

                    targetArr = [];

                    for(let x=0; x < targetBundleChildren.length; x++){
                      targetArr.push(targetBundleChildren[x].id)
                    }
                    targetArr.splice(targetIndex, 0, bundle.id)
              }
                
             
          }

          var rePosition = false;
          var nextPos = null

           if(targetId == 'root'){

              if(!this.treeNoInbox[targetIndex]){
                let prev = this.treeNoInbox[targetIndex - 1].p
                newPos = prev + 16000
              } else if(targetIndex == 0) {
                newPos = this.treeNoInbox[targetIndex].p / 2
                if(newPos < this.posThreshold){
                  rePosition = true
                  newPos = 16000
                  nextPos = this.treeNoInbox[targetIndex].p
                }
              } else if(targetIndex == this.treeNoInbox.length){
                newPos = this.treeNoInbox[targetIndex].p + 16000
              } else {
                let prev = this.treeNoInbox[targetIndex - 1].p
                let curr = this.treeNoInbox[targetIndex].p
                newPos = ((curr-prev) / 2) + prev
                if(curr-prev < this.posThreshold){
                  rePosition = true
                  newPos = prev + 16000
                  nextPos = this.treeNoInbox[targetIndex].p
                }
              }

              if(newPos < 1.8e-38)
                newPos = 1.8e-38

          }

          let newTarget = null
          if(targetId == 'root'){
            newTarget = 'root'
          } else if(aliasTgtId){
            newTarget = aliasTgtId
          } else {
            newTarget = targetId
          }

         

          /* if(alias){
            if(alias.aliasTgtId){
              parentId = alias.aliasTgtId
            }
          } */

          self.movingAdding = moveAddSpinnerTarget ? moveAddSpinnerTarget : targetId
          this.$root.app.apiClient.put('subs/data/bundleMove', {parentArr: parentArr.toString(), targetArr: targetArr.toString(), same: same, parentId: same ? aliasTgtId || tempParent : tempParent, targetId: newTarget, bundleId: bundle.id, newPos: newPos, reposition: rePosition, nextPos: nextPos, parentCollabId: parentCollabId, tgtCollabId: collabId, rootId: rootId, tgtRootId: tgtRootId}, w, n);

      },

      refreshNow: function(){

        this.InitialDataLoad(true);

        this.closeModal();
      },

     /*  sourceIcon: function(site){
        if(site == 'www.facebook.com' || site == 'facebook.com'){
                return `<img src="${require('@/assets/img/facebook.png')}" width="30">`
            } else if(site == 'www.instagram.com' || site == 'instagram.com'){
                return `<img src="${require('@/assets/img/instagram.png')}" width="30">`
            } else if(site == 'www.twitter.com' || site == 'twitter.com'){
                return `<img src="${require('@/assets/img/twitter.png')}" width="30">`
            } else if(site == 'www.youtube.com' || site == 'youtube.com'){
                return `<img src="${require('@/assets/img/youtube.png')}" width="30">`
            } 
            else {
                return ''
            }
      }, */

     

      tabsToMiimus: function(tabs){


        if(tabs.length == 0){
          return
        }
          
        var self = this;

        function w(d){
     
          self.$refs.mainModal.$children[0].showCheckMark = true;
          setTimeout(function(){
            
            top.window.postMessage({data: {message: 'closeIt'}}, "*");
          }, 500)
        }

        function n(){


        }
        var listName =  self.$refs.mainModal.$children[0].chromeBundleName
        this.apiClient.post('subs/data/chrometabs', {listName: listName, tabs: tabs}, w, n)
      },

       

      InitialDataLoad: function(reload){
            console.log('LOADING')

      
            var self = this;
            var partialLoad = 't'


       

            if(reload){
              partialLoad = 'f'
              var state = []
              this.$refs.routerView.$refs.rootBundleContainers.forEach(e => {
                state.push(e.conts.id)
              })
              
            }

            //if(self.$root.app.tree == undefined){

                if(self.$route.fullPath == '/bundles' || self.$route.fullPath == '/bundles?prev=1'){
                  if(document.getElementById('board')){
                    //az.addRemSpinner2(true, 'id', 'app');
                    document.getElementById('animation').style.display = "block"
                  }
                }
                 

                function w(data) {

                  self.dataTime = data.dataTime;
                  

                  if(self.$route.fullPath == '/bundles'  || self.$route.fullPath == '/bundles?prev=1'){
                    if(document.getElementById('board')){
                      //az.addRemSpinner2(false, 'id', 'app');
                      document.getElementById('animation').style.display = "none"
                    }
                  }

                  

                   
                  loadUp(data.response)

                 
                  self.ads = data.response.ads;
                
                  
                  let arr = data.response.tagUniverse

                  arr = arr.filter(e => {
                    return e.tag
                  })

                  let tu = {}
                  arr.forEach(e => {
                     tu[e.tag] = e.tag
                  })
                  self.tagUniverse = tu
                  

                  self.groupMembers = data.response.groups

                  for(let o = 0; o < data.response.nots.length; o++){
                    if(data.response.nots[o].markAsRead == 0){
                      self.unRead += 1
                      self.notifications = true
                      
                    }
                  }

                  self.nots = data.response.nots

                  self.userAttrs.profile = data.response.prof
                  self.userAttrs.hasUpgraded = data.response.subInfo.hasUpgraded;
                  self.userAttrs.bundleLimit = data.response.subInfo.bundleLimit;
                  self.userAttrs.cardLimit = data.response.subInfo.cardLimit;


                  if(reload){
                    
                    setTimeout(function(){
                      state.forEach((e, ite) => {
                      
                        var b
                        for(var x = 0; x < self.bundles.length; x++){
                          if(self.bundles[x].id == e){
                            b = self.bundles[x]
                          }
                        }
                        self.$refs.routerView.$refs.rootBundleContainers[ite].data = b;
                        
                      })
                     
                    }, 1)
                  
                  }
                
                  
                  
                }

                function n (data, status, headers, config, msg, errorRequest) {
                  if(self.$route.fullPath == '/bundles'  || self.$route.fullPath == '/bundles?prev=1')
                    if(document.getElementById('board')){
                      az.addRemSpinner2(false, 'id', 'app');
                      document.getElementById('animation').style.display = "none"
                    }
                }
                let getDataCards = 't'
               
                if(az.noSlash(self.$route.path) == '/extension')
                  getDataCards = 'f'

                self.$root.app.apiClient.get('subs/data/alldata/' + getDataCards + '-' + partialLoad, {}, w, n);
            /* } else {
              self.loaded = true
            } */

           

            function loadUp(data){   

              self.loaded = true
           
              self.ratings = data.ratings || [];
              self.ratingsAvg = data.ratingsAvg || [];
              self.ratingsMemAvg = data.memberAvg || [];

              self.bundleGroups = data.bundleGroups || []

              let localCards = data.cards

              for(var l = 0; l < data.bundles.length; l++){
                data.bundles[l].items = [];

                data.bundles[l].loadCount = 20;

                if(data.bundles[l].children){
                  data.bundles[l].children = data.bundles[l].children.split(',')
                } else {
                  data.bundles[l].children = []
                }

                data.bundles[l].branch = [data.bundles[l].id]

                if(data.bundles[l].isRoot && !reload){
                  data.bundles[l].itemsLoaded = true
                } else if(reload){
                  data.bundles[l].itemsLoaded = true
                }
              }

             

              self.$root.app.bundles = data.bundles
              self.$root.app.cards = localCards

              //offer welcome tour if no cards
              if(self.cards.length == 0 && self.bundles.length == 1){
                  self.showWelcome()
              }
              
                     
              for(var i = 0; i < self.$root.app.cards.length; i++){
                  
                    var ind;
                    var parents = JSON.parse(self.$root.app.cards[i].parents) || []
                    self.$root.app.cards[i].parents = JSON.parse(self.$root.app.cards[i].parents)
                    self.$root.app.cards[i].tags = JSON.parse(self.$root.app.cards[i].tags) || []

                    self.$root.app.cards[i].myCard = false
                    if(self.$root.app.userAttrs.sub != self.$root.app.cards[i].id_cog){
                      self.$root.app.cards[i].myCard = false
                    } else {
                      self.$root.app.cards[i].myCard = true
                    }
                    
                    for(var x = 0; x < parents.length; x++){

                      ind = self.$root.app.bundles.findIndex(e => {
                          return e.id == parents[x].id
                      })

                      if(ind != -1){
                          self.$root.app.bundles[ind].items.push({id: self.$root.app.cards[i].id, p: parents[x].p, cardsIndex: i, entryId: parents[x].entryId, id_cog: self.$root.app.cards[i].id_cog})
                      } else {
                        //console.log(self.$root.app.cards[i].id + ' -- ' + parents[x].id)
                      }
                        
                    }

                    //ratings
                   
                    let cd = self.$root.app.cards[i];
                    let myRatings = []
                    for(var l=0; l < self.ratings.length; l++){
                      if(self.ratings[l].id_CARDS == cd.id){
                        myRatings.push({collabId: self.ratings[l].id_COLLAB, rating:  self.ratings[l].rating})
                      }
                    }

                    let avgRatings = []
                    for(l=0; l < self.ratingsAvg.length; l++){
                      if(self.ratingsAvg[l].id_CARDS == cd.id){
                        avgRatings.push({collabId: self.ratingsAvg[l].id_COLLAB, rating:  self.ratingsAvg[l].rating})
                      }
                    }

                    let memberAvg = []
                    for(l=0; l < self.ratingsMemAvg.length; l++){
                      if(self.ratingsMemAvg[l].id_CARDS == cd.id){
                        memberAvg.push({collabId: self.ratingsMemAvg[l].id_COLLAB, rating:  self.ratingsMemAvg[l].rating})
                      }
                    }

                    cd.myRatings = myRatings;
                    cd.avgRatings = avgRatings;
                    cd.avgMemRatings = memberAvg;

                 

                    

              } 
              
              
             

              for(var n=0; n < self.$root.app.bundles.length; n++){

                if(self.$root.app.bundles[n].items){
                  self.$root.app.bundles[n].items.sort(function(a,b){ return a.p - b.p})
                } 
              }

              self.bundles.forEach(e => {
                if(e.isAlias){
                  let tgtB = self.bundles.find(b => {
                    return b.id == e.aliasTgtId
                  })

                  if(tgtB){
                   e.children = tgtB.children;
                   e.listName = tgtB.listName;
                   e.items = tgtB.items;
                   e.collabId = tgtB.collabId
                   e.isPublic = tgtB.isPublic
                   e.pubNote = tgtB.pubNote ? tgtB.pubNote : ''
                   tgtB.hideIt = true
                  } else {
                    e.isRoot = false
                    console.log('missing bundle -- ' + e.aliasTgtId)
                  }
                }
              })
            
               
              if(self.$root.app.bundles.length)
                self.buildTree(self.$root.app.bundles);   
                
              
         
             /*  self.$root.app.tree.sort(function(a,b){ return a.p - b.p})
              self.$root.app.treeNoInbox = self.$root.app.tree.slice(1); */

              
          
              var sts = data.states
              sts.forEach(e => {
                  if(e.param == 1){
                    self.showImages = e.val
                  } else if(e.param == 2){
                    self.bundlesOpen = e.val
                  } else if(e.param == 3){
                    self.showRatings = e.val
                  } else if(e.param == 4){
                    self.fulled = e.val
                    if(self.fulled){
                      setTimeout(function(){
                        self.fulledBundle = self.$refs.routerView.currView[0].id
                      }, 1020)
                      
                    }
                  } else if(e.param == 5){
              

                    var nmG = self.bundleGroups.find(n => {
                      return n.id == e.val
                    })

                    var nm
                    if(!nmG){
                      nm = 'All'
                    } else {
                      nm = nmG.name
                    }

  
                    setTimeout(function(){
                      if(self.$refs.routerView.viewChanged)
                        self.$refs.routerView.viewChanged(e.val, nm)
                    }, 1020)
                      
                    
                  } else if(e.param == 6){
                    self.showContext = e.val
                  } else if(e.param == 7){
                    self.showAds = e.val
                  } 
                })

                
              
             
              self.loaded = true;
             
              if(az.noSlash(self.$route.path) == '/extension' && self.$route.query.inApp){
                window.webkit.messageHandlers.myMessageName.postMessage('loaded')
              }
              
              
             
              if(reload){
                self.fullLoad = true
              }


            }

           
      },

      buildTree: function(o){

        var self = this; 
        var hasDirtyBundles = false

        self.$root.app.tree.length = 0
        self.$root.app.treeNoInbox.length = 0

        var allBids = []
        self.$root.app.bundles.forEach(x => {
          allBids.push(x.id)
        })

      
       
     
        

        function getChildren(ids, branch, collabId){
          var ret = []
          
          for(var i=0; i < ids.length; i++){

            
           
              //if id is not in bundles array, continue
              if(!allBids.includes(parseInt(ids[i]))){
                continue
              } 


                var newBranch = branch.concat([ids[i]])

                ret.push(o.find(function(e){
                  if(e.id == ids[i]){

                    e.branch = newBranch
                    e.processed = true
                    e.parentCollabId = collabId

                    if(e.dirt > 0){
                      hasDirtyBundles = true
                    }
                    
                    if(e.children.length > 0){
                      e.children = getChildren(e.children, newBranch, collabId)
                    }
                    return true
                  }
                  
                    
                })
              )
              
            }
            return ret
        }

        var arr = []

        //for(var i=0; i < o.length; i++){
        var i = 0;
        //var reachedNull = false
        var inter = setInterval(() => {

          var e = o[i];

        
           /* if(e.p == null && !reachedNull){
              self.$root.app.tree.sort(function(a,b){ return a.p - b.p})
              self.$root.app.treeNoInbox = self.$root.app.tree.slice(1);
              reachedNull = true;
            } */
          if(e.hasOwnProperty('processed') || e.isRoot == false || e.hideIt){


          } else {

            hasDirtyBundles = false

            if(e.children.length > 0){
              e.children = getChildren(o[i].children, [o[i].id], e.collabId || null);
            } else {

            }


            e.branch = [e.id]
            e.processed = true

            if(hasDirtyBundles || e.dirt > 0){
              e.hasDirtyBundles = true
            } else {
              e.hasDirtyBundles = false
            }

            if(e.collabId){
              e.parentCollabId = e.collabId
            } else {
              e.parentCollabId = null
            }

            arr.push(e);

            self.$root.app.tree.push(e)
            if(!e.isInbox)
              self.$root.app.treeNoInbox.push(e)

            
           
            //self.$root.app.$refs.routerView.forceUpdate()
          }

          i++
          if(i == o.length){
            clearInterval(inter)
          }

        }, 5)

        //return arr
      },

      showWelcome: function(){
        this.doShowModal('Welcome')
      },

      openNotifications: function(){
        if(!this.isAuth) return
        this.rightBarComponent = 'notifications'
        this.rightBar = true
      },

      checkDescendantsForForeign: async function(id){


          return new Promise((resolve, reject) => {

            function w(d){
              if(d.hasForeign)
                resolve(true)
              else {
                resolve(false)
              }
            }

            function n(){
              reject()
            }

            this.apiClient.get('subs/data/checkcollabforforeign/' + id, {}, w, n);


          })

     

        //let bundles = this.bundles
        /* var self = this;
        var hasF = false

        function rec(theId){
          var b 
          for(var i=0; i < self.bundles.length; i++){
            if(self.bundles[i].id == theId){
              b = self.bundles[i];
              break
            }
          }

         
          //check bundle owner
          if(b.id_cog != self.userAttrs.sub){
            hasF = true
          }

          //check card owners
          for(var x=0; x<b.items.length; x++){
            if(b.items[x].id_cog != self.userAttrs.sub){
              hasF = true
              break;
            }
          } 

          for(var l=0; l < b.children.length; l++){
             rec(b.children[l].id)
          }         

        }

        rec(id)

        return hasF */

      },

      loadOneCard: function(idToLoad){
        var self = this;
        
        return new Promise(function(resolve, reject){
      
            function w(d){
               var cards = d.response.cards
                         
             
               for(var i = 0; i < cards.length; i++){

                    var already = self.$root.app.cards.findIndex(e => {
                        resolve(true)
                        return e.id == cards[i].id
                    })

                    if (already != -1)
                        continue

                    var ind;
                    var parents = JSON.parse(cards[i].parents) || []
                    cards[i].parents = JSON.parse(cards[i].parents)
                    cards[i].tags = JSON.parse(cards[i].tags) || []

                    if(self.$root.app.userAttrs.sub != cards[i].id_cog){
                      cards[i].myCard = false
                    } else {
                      cards[i].myCard = true
                    }

                   

                    self.$root.app.cards.push(cards[i])
                    
                    for(var x = 0; x < parents.length; x++){

                      ind = self.$root.app.bundles.findIndex(e => {
                          return e.id == parents[x].id
                      })

                      if(ind != -1){
                          self.$root.app.bundles[ind].items.push({id: cards[i].id, p: parents[x].p, cardsIndex: self.$root.app.cards.length - 1, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                      }

                    }

                   

                    //ratings

                    d.response.ratings.forEach(e => {
                        self.$root.app.ratings.push(e)
                    })

                    d.response.ratingsAvg.forEach(e => {
                        self.$root.app.ratingsAvg.push(e)
                    })

                    let cd = self.$root.app.cards[self.$root.app.cards.length - 1];


                    let myRatings = []
                    for(var l=0; l < d.response.ratings.length; l++){
                      if(d.response.ratings[l].id_CARDS == cd.id){
                        myRatings.push({collabId: d.response.ratings[l].id_COLLAB, rating:  d.response.ratings[l].rating})
                      }
                    }

                    let avgRatings = []
                    for(l=0; l < d.response.ratingsAvg.length; l++){
                      if(d.response.ratingsAvg[l].id_CARDS == cd.id){
                        avgRatings.push({collabId: d.response.ratingsAvg[l].id_COLLAB, rating:  d.response.ratingsAvg[l].rating})
                      }
                    }

                    let avgMemRatings = []
                    for(l=0; l < d.response.memberAvg.length; l++){
                      if(d.response.memberAvg[l].id_CARDS == cd.id){
                        avgMemRatings.push({collabId: d.response.memberAvg[l].id_COLLAB, rating:  d.response.memberAvg[l].rating})
                      }
                    }

                    cd.myRatings = myRatings;
                    cd.avgRatings = avgRatings;
                    cd.avgMemRatings = avtMemRatings;

                   

                }  

                var arr = d.response.tagUniverse
                var tu = {}
                arr.forEach(e => {
                    tu[e.tag] = e.tag
                })
               
                arr.forEach(e => {
                    self.$root.app.tagUniverse[e] = e
                })

                 
                resolve(true)

            }

            function n(){
                reject(false)
            }
          
            self.apiClient.get('subs/data/card/' + idToLoad, {}, w, n)
        })
      },

      loadUserBundles: function(){   //This is the inject version for loading, complete loading is InitialDataLoad()
        var self = this
      
        az.addRemSpinner(true, 'id', 'refreshBTContainer')

        
          var allBids = []

          function getChildren(ids, branch, collabId){
                var ret = []
                
               
                
                for(var i=0; i < ids.length; i++){

                   //if id is not in bundles array, continue
                   if(!allBids.includes(parseInt(ids[i]))){
                      continue
                    } 

                    var newBranch = branch.concat([ids[i]])

                    ret.push(self.bundles.find(function(e){
                      if(e.id == parseInt(ids[i])){

                        e.branch = newBranch
                        e.processed = true
                        e.parentCollabId = collabId

                        if(e.dirt > 0){
                          hasDirtyBundles = true
                        }
                        
                     /*    if(e.children && e.children.length > 0){
                          e.children = getChildren(e.children, newBranch, collabId)
                        } */
                        return true
                      }
                        
                    }))
                  }
                  return ret
              }

        function w(d){
           az.addRemSpinner(false, 'id', 'refreshBTContainer')
            //BUNDLES

            //Traverse new bundles check if exsits in bundles, if does repleace otherwise add
            d.response.bundles.forEach(e => {

               
                e.items = [];

                if(e.children){
                  e.children = e.children.split(',')
                } else {
                  e.children = []
                }

          
                e.branch = [e.id]
                e.itemsLoaded = false
                e.forceLoadFromInject = true
                

                var ind = self.bundles.find(n => { 
                  var idd = n.aliasTgtId || n.id
                  return e.id == idd;
                })


                 var inddex = self.bundles.findIndex(n => { 
                  var idd = n.aliasTgtId || n.id
                  return e.id == idd;
                })

             
                if(!ind){
                  self.bundles.push(e)
                  if(e.isRoot){
                    self.tree.push(e)
                    self.treeNoInbox.push(e)
                  }
                } else {
                  if(ind.active == 0){
                    //e.hideIt = true
                  } else if(ind.isAlias){
                    //ind.children = e.children;
                    self.bundles[inddex].isPublic = e.isPublic
                    self.bundles[inddex].modDate = e.modDate
                    self.bundles[inddex].listName = e.listName;
                    //self.bundles[inddex].items = e.items;
                    //self.bundles[inddex].p = e.p
                    self.bundles[inddex].collabId = e.collabId
                    self.bundles[inddex].pubNote = e.pubNote ? e.pubNote : ''
                    self.bundles[inddex].rootId = e.rootId
                    e.hideIt = true
                  } else {
                    ind = e
                  }
                  e.injectFound = true
                  
                  self.bundles[inddex].active = e.active
                  //self.bundles[inddex].aliasTgtId = e.aliasTgtId
                  self.bundles[inddex].collabId = e.collabId
                  self.bundles[inddex].isPublic = e.isPublic
                  self.bundles[inddex].isRoot = e.isRoot
                  self.bundles[inddex].listName = e.listName
                  self.bundles[inddex].modDate = e.modDate
                  self.bundles[inddex].privNote = e.privNote
                  self.bundles[inddex].pubNote = e.pubNote
                  self.bundles[inddex].rootId = e.rootId

                

                  //self.bundles[inddex].p = e.p
                }
            })

            self.$root.app.bundles.forEach(x => {
              allBids.push(x.id)
            })

            d.response.bundles.forEach(e => {
               
                var inddex = self.bundles.findIndex(n => { 
                  var idd = n.aliasTgtId || n.id
                  return e.id == idd;
                })

               if(e.children && e.children.length > 0){

                  self.bundles[inddex].children = getChildren(e.children, self.bundles[inddex].branch, e.collabId || null);
                  
                } else  {
                  self.bundles[inddex].children = []
                }

                  //if bundle is currently in view and is not root, navigate up one level
                    if(!e.isRoot){
                      self.$refs.routerView.$refs.rootBundleContainers.forEach(rbc => {
                        if(rbc.conts.id == e.id){
                          rbc.loadRoot()
                        }
                      })
                    }
            })

            self.treeNoInbox.sort((a,b) => {
              return a.p - b.p
            }) 
            self.tree.sort((a,b) => {
              return a.p - b.p
            })

          //if(d.response.bundles.length){
           //do cards after buildTreeForInject has finished
            //buildTreeForInject(d.response.bundles)
          //} else {
            self.cardsInject(d.response.cards, d.response.ratings, d.response.ratingsAvg, d.response.memberAvg, d.response.tagUniverse, d.response.nots, d.response.bundleGroups)
         // }
            
            self.dataTime = d.dataTime;
            self.loaded = true

                      


          //////

            function rec(id, arr){
        
                    var res = null
                    var done = false
                    function rec2(arr2){
                     
                      for(var x=0; x < arr2.length; x++){
                        
                        for(var m=0; m < arr2[x].children.length; m++){
                          if(arr2[x].children[m].id == id){
                              res = arr2[x]
                              done = true
                              break
                          }

                        }

                        if(done)
                          break
                      
                      
                        if(arr2[x].children.length){
                          rec2(arr2[x].children)
                        }
                      }
                    }

                    rec2(arr)
                    
                    return res
            }     
              
            function findInTrees(id, arr){
        
                    var res = null
                    
                    function rec2(arr2){
                     
                      for(var x=0; x < arr2.length; x++){
                        
                        var nnn = arr2[x].aliasTgtId || arr2[x].id;
                        if(nnn == id){
                            res = arr2[x]
                            break
                        }
                    
                        if(arr2[x].children.length){
                          rec2(arr2[x].children)
                        }
                      }
                    }

                    rec2(arr)
                    
                    return res
            }      
        }

        function n(){
           az.addRemSpinner(false, 'id','refreshBTContainer')
        }

        //console.log('LOADiNG2')
 
        self.$root.app.apiClient.get('subs/data/alldata/t-i-' + new Date(self.dataTime).getTime(), {}, w, n);
      },

      cardsInject: function(cards, ratings, ratingsAvg, memberAvg, tagUniverse, nots, bundleGroups){


        var self = this;
        for(var i = 0; i < cards.length; i++){

              var already = self.$root.app.cards.findIndex(e => {
                  return e.id == cards[i].id
              })


              /*  if (already != -1)
                  continue */

              var ind;
              var parents = JSON.parse(cards[i].parents) || []
              cards[i].parents = JSON.parse(cards[i].parents)
              cards[i].tags = JSON.parse(cards[i].tags) || []

              if(self.$root.app.userAttrs.sub != cards[i].id_cog){
                cards[i].myCard = false
              } else {
                cards[i].myCard = true
              }

              //*push or splice
              if(already != -1){
                  self.$root.app.cards.splice(already, 1, cards[i])
                  cards[i].cardsIndexForInject = already
              } else {
            
                  self.$root.app.cards.push(cards[i])  
                  cards[i].cardsIndexForInject =  self.$root.app.cards.findIndex(t => {    //self.$root.app.cards.length - 1
                      return t.id == cards[i].id
                  })               
              }
              
              var arrOfParentIds = []
              for(var x = 0; x < parents.length; x++){

                ind = self.$root.app.bundles.findIndex(e => {
                    return e.id == parents[x].id
                })



                //*push or splice
                if(ind != -1){
                      arrOfParentIds.push(parents[x].id)
                      var itemIndex = self.$root.app.bundles[ind].items.findIndex(ii => {
                          return ii.id == cards[i].id;
                      })

                      
                      
                      if(itemIndex != -1){
                          self.$root.app.bundles[ind].items.splice(itemIndex, 1, {id: cards[i].id, p: parents[x].p, cardsIndex: already, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                      } else {
                          self.$root.app.bundles[ind].items.unshift({id: cards[i].id, p: parents[x].p, cardsIndex: cards[i].cardsIndexForInject, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                      }

                      self.$root.app.bundles[ind].items.sort( function(a,b){
                          return a.p - b.p
                      })
                }
                  
              }


              for(var bdel = 0; bdel < self.$root.app.bundles.length; bdel++){
                  var b = self.$root.app.bundles[bdel]
                  
                  if(b){
                    for(var ddel = 0; ddel < b.items.length; ddel++){
                        var idd = b.items[ddel].id
                        if(!arrOfParentIds.includes(b.id) && idd == cards[i].id){
                            b.items.splice(ddel, 1)
                            break
                        }
                    }
                  }
              }
          }

        
    

          //ratings
          ratings.forEach(r => {
            //find card
            var fc = self.cards.findIndex(cc => {
              return cc.id == r.id_CARDS
            })
            if(self.cards[fc]){

              for(var l=0; l < self.cards[fc].myRatings.length; l++){
                if(self.cards[fc].id == r.id_CARDS){
                  if(self.cards[fc].myRatings[l].collabId == r.id_COLLAB){
                    self.cards[fc].myRatings.splice(l, 1, {collabId: r.id_COLLAB, rating:  r.rating})
                  } else {  
                    self.cards[fc].myRatings.push({collabId: r.id_COLLAB, rating:  r.rating})
                  }                  
                }
              }

              self.cards.splice(fc, 1, self.cards[fc])
             
            } 
           
          })

          //member avg
          memberAvg.forEach(r => {
            //find card
            var fc = self.cards.findIndex(cc => {
              return cc.id == r.id_CARDS
            })
            if(self.cards[fc]){

              for(var l=0; l < self.cards[fc].avgMemRatings.length; l++){
                if(self.cards[fc].id == r.id_CARDS){
                  if(self.cards[fc].avgMemRatings[l].collabId == r.id_COLLAB){
                    self.cards[fc].avgMemRatings.splice(l, 1, {collabId: r.id_COLLAB, rating:  r.rating})
                  } else {  
                    self.cards[fc].avgMemRatings.push({collabId: r.id_COLLAB, rating:  r.rating})
                  }                  
                }
              }

              self.cards.splice(fc, 1, self.cards[fc])
             
            } 
           
          })

          ratingsAvg.forEach(r => {
            //find card
            var fc = self.cards.findIndex(cc => {
              return cc.id == r.id_CARDS
            })
            if(self.cards[fc]){
            for(var l=0; l < self.cards[fc].avgRatings.length; l++){
                  if(self.cards[fc].id == r.id_CARDS){
                    if(self.cards[fc].avgRatings[l].collabId == r.id_COLLAB){
                      self.cards[fc].avgRatings.splice(l, 1, {collabId: r.id_COLLAB, rating:  r.rating})
                    } else {  
                      self.cards[fc].avgRatings.push({collabId: r.id_COLLAB, rating:  r.rating})
                    }                  
                  }
                }
            self.cards.splice(fc, 1, self.cards[fc])
             
            } 
           
          })

          tagUniverse.forEach(e => {
            self.$root.app.tagUniverse[e.tag] = e.tag
          })

          nots.forEach(n => {
            if(n.markAsRead == 0){
              self.notifications = true
              self.unRead += 1
            }
            for(var x=0; x < self.nots.length; x++){
              if(self.nots[x].id == n.id){
                self.nots.splice(x, 1, n)
                break
              }
            }
             self.nots.push(n)
          })


          bundleGroups.forEach(b => {
            for(var xx=0; xx < self.nots.length; xx++){
              if(self.nots[xx].id == b.id){
                self.nots.splice(xx, 1, b)
                break
              }
            }
             self.nots.push(b)
          })
      },

      onResize: function() {
          this.windowWidth = window.innerWidth
      },

      toggleBurger: function(e){   
        if(e.stopPropagation)
          e.stopPropagation()
        document.getElementById('burger').classList.toggle('is-active')
        document.getElementById('miimuMenu').classList.toggle('is-active')

        

        if(document.getElementById('miimuMenu').classList.contains('is-active')){
          this.$refs.routerView.$refs.theInbox.$el.style.top = '55px'
          //this.hideSearch = true
        } else {
          this.$refs.routerView.$refs.theInbox.$el.style.top = 0
          //this.hideSearch = false
        }
        
      },

      //Tour callbacks

      onSkip: function(){
          this.showTourMasks = false
          this.$tours['myTour'].currentStep = -1

      },

      onStop: function(){
          this.showTourMasks = false
          this.$tours['myTour'].currentStep = -1
      },

      onFinish: function(){
          this.showTourMasks = false
          this.$tours['myTour'].currentStep = -1
      },

      logImpression: function(id){
          var self = this
          function w(d){
           
          }
          function n(){

          }

          var viewer = 'public'
          if(self.userAttrs.sub){
              viewer = self.userAttrs.sub;
          }
          this.apiClient.post('open/init/logimpressions', {id: id, viewer: viewer}, w, n)
      },

      logAdClick: function(id){
          var self = this
          function w(d){
            //console.log(d)
          }
          function n(){

          }
          var viewer = 'public'
          if(self.userAttrs.sub){
              viewer = self.userAttrs.sub;
          }
          this.apiClient.post('open/init/logadclicks', {id: id, viewer: viewer}, w, n)
      },

      loadScript(src, callBack) { // async loader of scripts
        if (!this.asyncScripts.includes(src)) {
          this.asyncScripts.push(src)
          var azScriptLoader = Vue.extend(ScriptLoader)
          this.l = new azScriptLoader({
            propsData: { src: src, callBack: callBack }
          })
        } else {
          callBack()
        }
	    },

      loopLoadBundles: function(bundle){

        var self = this;
        //list all ids contained in bundle
        var b = this.treeNoInbox.find(e => {
          return e.id == id
        })
        
        var ret = []
        function getChildren(ids){

               for(var i=0; i < ids.length; i++){

                    ret.push(ids[i].id)

                    if(ids[i].children.length){
                      getChildren(ids[i].children)
                    }
                }

                return ret
          }
        
        
         return getChildren([bundle])
         
      },

      getPreviewURL: function(){ //for app to get URL
       // return this.app.$refs.mainMenuOpen.dispUrl;
      },

      deleteCard: function( id){
            
            var self = this;

            var card = this.$root.app.cards.find((e) => {
                return e.id == id
            })

            var cardParents = []
            if(card != null){
              cardParents = card.parents
            } 
          

           /* var theB = self.$parent.conts.aliasTgtId || self.$parent.conts.id
           var tgtParent = cardParents.find((e) => {
               return e.id == theB
           })
          
           var entryId = tgtParent.entryId */

           function w(data){
       
               
               if(data.response == 'ok'){
                      
                       for(var x=0; x < cardParents.length; x++){

                           var dex = self.$root.app.bundles.findIndex(e => {
                                return e.id == cardParents[x].id
                           })

                           var t = self.$root.app.bundles[dex].items.findIndex(e => {
                               return e.id == id
                           })
                           self.$root.app.bundles[dex].items.splice(t, 1)

                        
                       }

               }
               self.$root.app.closeModal()
           }

           function n(){
        
               self.$emit('close')
               self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
           }

   
           this.$root.app.apiClient.delete('subs/data/card', {cardId: id, selOption: 'all'}, w, n);
       },

    },
    watch:{
      showModal: function(){
        if(this.showModal == true){
          this.blurBG();
        }	else {
          this.unBlurBG();
        }
      },

      windowWidth(newW, oldW) {
            if(newW < 1024){
              this.isMobile = true
            } else {
              this.isMobile = false
            }
      }
	  },

   
  }
</script>

<style>

</style>
